var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useDareDropApi } from 'root/src/client/v2/common/hooks/useDareDropApi';
import { useQuery } from '@tanstack/react-query';
import { rewardEndpointIds, RewardType } from 'root/src/shared/rewards/constants';
import { useMemo } from 'react';
const useDecryptedRewardQuery = (rewardId) => {
    const { fetcher } = useDareDropApi();
    return useQuery({
        queryKey: [rewardEndpointIds.GET_DECRYPTED_REWARD, rewardId],
        queryFn: () => __awaiter(void 0, void 0, void 0, function* () {
            return fetcher({
                endpointId: rewardEndpointIds.GET_DECRYPTED_REWARD,
                payload: {
                    rewardId,
                },
            });
        }),
        refetchOnWindowFocus: true,
    });
};
const STEAM_REGISTER_KEY_URL = 'https://store.steampowered.com/account/registerkey';
export const useRedeemedReward = (reward) => {
    const giftedRewardId = reward.fullId
        .replace(RewardType.DELIVERED_KEY, RewardType.GIFTED_KEY)
        .replace(RewardType.DELIVERED_CODE, RewardType.GIFTED_CODE);
    const decryptedRewardQuery = useDecryptedRewardQuery(giftedRewardId);
    const rewardURL = useMemo(() => {
        if (decryptedRewardQuery.isLoading) {
            return '';
        }
        if (reward.platform === 'steam') {
            return `${STEAM_REGISTER_KEY_URL}?key=${decryptedRewardQuery.data}`;
        }
        return reward.url;
    }, [decryptedRewardQuery, reward]);
    const rewardCTA = useMemo(() => {
        if (decryptedRewardQuery.isLoading) {
            return '';
        }
        if (reward.platform === 'steam') {
            return 'Activate on Steam';
        }
        return `Use code at ${reward.url}`;
    }, [reward, decryptedRewardQuery]);
    return {
        decryptedRewardQuery,
        rewardURL,
        rewardCTA,
    };
};
